import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18.75 2.5H20v15h-1.25v-15zM1.25 7.25v-1H0v7.5h1.25v-1l5 1.125V16c0 .875.625 1.75 1.5 2l2.125.625c1.375.375 2.625-.625 2.625-2V15.25l5 1.125V3.75L1.25 7.25zm6.25 6.875l3.75.75V16.5c0 .375-.25.625-.375.625s-.375.375-.75.25L8 16.75c-.25-.125-.5-.375-.5-.75v-1.875z',
  ],
  height: 20,
  width: 20,
});
